module.exports = __webpack_public_path__ + "arrived-today.png?099eff69e20fb7ff868e1c92bd3f72cd";